import { Component, Input, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Compiler, ViewChild, OnChanges, OnInit, SimpleChanges, Renderer2 } from '@angular/core';
import * as $ from 'jquery';

import { ProductService } from '../../services/product.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AppSettings } from 'src/app/enums/app-settings.enum';
declare var document: any;
declare var Swiper: any;
declare var window: any;
const componentList: Array<string> = ['footer', 'footerQuickLinkSection', 'mainNavigation', 'topNavigation'];

@Component({
  selector: 'app-view-cms-content',
  templateUrl: './view-cms-content.component.html',
  styleUrls: ['./view-cms-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ViewCmsContentComponent implements OnChanges {
  className: string;
  @Input() cmsContentUrl?: string;
  @Input() cmsContentId?: string;

  @ViewChild('htmlContainer') container;
  test;
  trustedHTML: any;
  constructor(
    private productService: ProductService,
    private UTS: UtilitiesService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private R: Renderer2) {

  }


  ngOnChanges(changes: SimpleChanges): void {
    // if (changes['cmsContentId']) {
    //   this.className = this.updateClass();
    // }
    if (this.cmsContentUrl) {

      setTimeout(() => {

        this.productService
          .getCMSContent("/" + this.cmsContentUrl, 'GET')
          .subscribe((res: any) => {

            this.trustedHTML = this.sanitizer.bypassSecurityTrustHtml(res.htmlSrc.toString());

            // setTimeout(() => { //wait for DOM rendering
            //   let scripts = this.container.nativeElement.getElementsByTagName('script');
            //   for (let script of scripts) {
            //     if (script && script.text) {
            //       eval(script.text)
            //     }
            //   }
            //   if (this.cmsContentId == 'footer') {
            //     this.getHeaderLibs(AppSettings.HEADER_LIBS).then(res => {
            //       this.getFooterLibs(AppSettings.FOOTER_LIBS);
            //     })
            //   }
            //   setTimeout(() => {
            //     window.DYNAMIC_COMPONENTS.loadAll();
            //   }, 1500);
            // })
            this.cdr.detectChanges();
            // const currentLang = $('#mainIndex').attr('lang');
            // $('#language').on('click', (e: any) => {
            //   e.preventDefault();
            //   if (window.location.href.indexOf('/b2c/') > 0) {
            //     if (currentLang && currentLang.toString().toLowerCase() == 'en')
            //       window.location.href = this.updateQueryStringParam('AR');
            //     else if (
            //       currentLang &&
            //       currentLang.toString().toLowerCase() == 'ar'
            //     )
            //       window.location.href = this.updateQueryStringParam('EN');
            //   }
            //   this.cdr.detectChanges();
            // });
          }, (e) => {

          });
      }, 1500);
    } else {
      this.trustedHTML = '';
    }
  }


  private updateClass() {
    const isValid = componentList.includes(this.cmsContentId);
    return (isValid ? 'aem-spa-wrap' : '');
  }
  private updateQueryStringParam(value: string): string {
    const key = 'locale';
    var keyRegex = new RegExp(`([\?&])${key}[^&]*`);
    const baseUrl = `${location.protocol}//${location.host}${location.pathname}`;
    const urlQueryString = document.location.search;
    const newParam = `${key}=${value}`;
    if (urlQueryString) {
      if (urlQueryString.match(keyRegex) !== null)
        return `${baseUrl}${urlQueryString.replace(keyRegex, '$1' + newParam)}`;
      else return `${urlQueryString}&${newParam}`;
    }
    return `${baseUrl}${newParam}`;
  }


  async getHeaderLibs(headerUrl) {
    this.productService
      .getLibs("/" + headerUrl, 'GET')
      .subscribe((res: any) => {
        if (res?.htmlSrc) {
          this.loadScripts(res.htmlSrc, document.getElementById('headerLibs'), 'header');
        }

      }, (e) => {
      });
  }
  async getFooterLibs(footerUrl) {

    await this.productService
      .getCMSContent("/" + footerUrl, 'GET')
      .subscribe((res: any) => {
        if (res?.htmlSrc) {
          this.loadScripts(res.htmlSrc, document.getElementById('footerLibs'), 'footer')
        }
        setTimeout(() => {
          window.DYNAMIC_COMPONENTS.loadAll();
        }, 1500);
      }, (e) => {
      }, () => {
      });
  }
  loadScripts(htmlStr: string, targetEl: any, type: string) {
    let domParser = new DOMParser();
    const html = domParser.parseFromString(htmlStr, 'text/html');
    // let length = (type == 'header') ? 1 : html?.scripts.length

    let length =  html?.scripts.length;//(type == 'header') ? 1 :
    for (let index = 0; index < length; index++) {
      const script = html.scripts[index];
      let scriptTag = this.R.createElement('script');
      scriptTag.type = 'text/javascript';
      scriptTag.src = script.src;
      scriptTag.async = true; // makes script run asynchronously
      this.R.appendChild(targetEl, scriptTag);
    }
  }
}